if (!customElements.get('m-legal-text')) {
  class LegalText extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.toggleButton = this.querySelector('.m-legal-text__toggle');
      this.previewElement = this.querySelector('.m-legal-text__preview');
      this.fullTextElement = this.querySelector('.m-legal-text__full');
      this.showMoreText = this.toggleButton.querySelector('.show-more');
      this.showLessText = this.toggleButton.querySelector('.show-less');
      this.isExpanded = false;

      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', this.toggleContent.bind(this));
      }
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.previewElement.style.display = 'none';
        this.fullTextElement.style.display = 'block';
        this.showMoreText.style.display = 'none';
        this.showLessText.style.display = 'inline';
      } else {
        this.previewElement.style.display = 'block';
        this.fullTextElement.style.display = 'none';
        this.showMoreText.style.display = 'inline';
        this.showLessText.style.display = 'none';
      }
    }
  }

  customElements.define('m-legal-text', LegalText);
}
